import { render, staticRenderFns } from "./auth.vue?vue&type=template&id=3db74d53"
import script from "./auth.vue?vue&type=script&lang=js"
export * from "./auth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jenkins/workspace/web-SaaS/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3db74d53')) {
      api.createRecord('3db74d53', component.options)
    } else {
      api.reload('3db74d53', component.options)
    }
    module.hot.accept("./auth.vue?vue&type=template&id=3db74d53", function () {
      api.rerender('3db74d53', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/auth.vue"
export default component.exports